import React, {useRef, useState} from "react";
import {useEffectOnce} from "../../../hooks/useEffectOnce";
import * as GroupGameService from "../../../api/GroupGameService"
import Draggable from 'react-draggable';

import {
    ControlBar,
    LiveKitRoom,
    ParticipantTile,
    useTracks,
} from '@livekit/components-react';
import '@livekit/components-styles';
import {Track} from 'livekit-client';
import liveKitStyle from "./LiveKitCallScreen.module.css";
import {deepPurple} from "@mui/material/colors";
import HeightIcon from "@mui/icons-material/Height";
import CustomCarouselLayout from "./CustomCarouselLayout.tsx"
import CustomRoomAudioRenderer from "../../../screens/CustomRoomAudioRenderer.tsx";
import MusicNoteIcon from "../../../screens/MusicNoteIcon";
import BackgroundMusic from "./BackgroundMusic";
import CloseFullscreenIcon from "@mui/icons-material/CloseFullscreen";
import OpenInFullIcon from "@mui/icons-material/OpenInFull";

const serverUrl = 'wss://leelaonline-yry7yf2y.livekit.cloud';
function LiveKitCallScreen(props) {

    const [lkToken, setLkToken] = useState()
    const [backgroundMusicFolded, setBackgroundMusicFolded] = useState(true)
    const [enlarged, setEnlarged] = useState(false)
    const drugableNodeRef = useRef()
    const [callScreenPosition, setCallScreenPosition] = useState({x: -200, y:200})


    function MyVideoConference() {
        // `useTracks` returns all camera and screen share tracks. If a user
        // joins without a published camera track, a placeholder track is returned.
        const tracks = useTracks(
            [
                {source: Track.Source.Camera, withPlaceholder: true},
                {source: Track.Source.ScreenShare, withPlaceholder: false},
            ],
            {onlySubscribed: false},
        );


        return (
            <CustomCarouselLayout
                tracks={tracks}
                orientation={props.isHorizontal ? "horizontal" : "vertical"}
                enlarged={enlarged}
            >
                <ParticipantTile style={{width: enlarged ? "425px" : "250px", height: enlarged ? "240px" : "140px"}}/>
            </CustomCarouselLayout>
        );
    }

    function onLiveKitAuth(response) {
        setLkToken(response.token)
    }

    function flipDirection() {
        props.setHorizontal(!props.isHorizontal)
    }

    useEffectOnce(() => {
        GroupGameService.getLiveKitToken(
            props.game_id,
            props.user_id,
            props.user_name,
            onLiveKitAuth,
            () => {
                window.alert("Failed to get LiveKit credentials")
            })
    })

    function handleDragEnd(event, data) {
        setCallScreenPosition({x: data.lastX, y: data.lastY})
        if (event.target.className !== "newhandle" && (Math.abs(data.deltaX) + Math.abs(data.deltaY) < 20)) {

            event.target?.click?.()
        }
    }

    return <Draggable
        nodeRef={drugableNodeRef}
        axis="both"
        handle=".newhandle"
        position={callScreenPosition}
        scale={1}
        bounds="#boundaries"
        onStop={handleDragEnd}
    >
        <div ref={drugableNodeRef} className="newhandle"
             style={{display: "flex", flexDirection: "column", width: 120, position: "absolute", zIndex: 1005, cursor:"move"}}>
            <div className={liveKitStyle.lkVideoDraggableComponent}>
                <div className={liveKitStyle.lkHandle}>
                    <div onClick={() => setEnlarged(!enlarged)} onTouchEnd={() => setEnlarged(!enlarged)}>
                        {enlarged ?
                            <CloseFullscreenIcon fontSize="small" sx={{color: deepPurple[50], cursor: "zoom-out"}}/>
                            :
                            <OpenInFullIcon fontSize="small" sx={{color: deepPurple[50], cursor: "zoom-in"}}/>}
                    </div>
                    <HeightIcon
                        sx={{color: deepPurple[50], cursor: props.isHorizontal ? "ns-resize" : "ew-resize"}}
                        onClick={flipDirection}
                        onTouchEnd={flipDirection}
                        className={props.isHorizontal ? liveKitStyle.flipped0 : liveKitStyle.flipped90}
                    />


                </div>
                <LiveKitRoom
                    video={{resolution: {width: 425, height: 240, frameRate: 25}}}
                    audio={{echoCancellation: true, noiseSuppression: true}}
                    token={lkToken}
                    serverUrl={serverUrl}
                    // Use the default LiveKit theme for nice styles.
                    data-lk-theme="default"
                    onDisconnected={props.onStop}
                    onError={(error) => {
                        window.alert("Call failed " + JSON.stringify(error))
                        props.onStop()
                    }}
                    onMediaDeviceFailure={(reason) => {
                        window.alert("Camera or microphone not accesible " + JSON.stringify(reason))
                        props.onStop()
                    }}
                    style={{backgroundColor: "unset", display: "flex", flexDirection: props.isHorizontal ? "row" : "column"}}
                    participant
                >

                    {/* Your custom component with basic video conferencing functionality. */}
                    {props.isMentor && <div
                        className={liveKitStyle.musicIcon}
                        style={{cursor: backgroundMusicFolded ? "s-resize" : "n-resize"}}
                        onClick={() => setBackgroundMusicFolded(!backgroundMusicFolded)}
                        onTouchEnd={() => setBackgroundMusicFolded(!backgroundMusicFolded)}
                    >
                        <MusicNoteIcon/>
                    </div>}
                    <BackgroundMusic folded={backgroundMusicFolded}/>
                    <MyVideoConference/>
                    {/* The RoomAudioRenderer takes care of room-wide audio for you. */}
                    <CustomRoomAudioRenderer/>
                    <ControlBar
                        style={{
                            position: "absolute",
                            display: "flex",
                            flexDirection: "row",
                            top: -53,
                            left: 5,
                            transform: "scale(0.68)",
                            gap: "3px"
                        }}
                        variation={"minimal"}
                        controls={{chat: false, screenShare: false,}}
                    />


                </LiveKitRoom>
            </div>

        </div>

    </Draggable>


}

export default React.memo(LiveKitCallScreen)